import {
  Button, Card, Col, Flex, Row,
  Typography
} from "antd";

import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import classes from "./onboarding.module.css";
import OnboardingModal from "./onboardingModal";
import useOnboarding from "./useOnboarding";

const {
  Title,
  Text
} = Typography;

const Onboarding = () => {
  const { t } = useTranslation();
  const {
    isModalOpen,
    toggleModal,
    data: OnboardingData
  } = useOnboarding();

  return (
    <>
      <Row
        gutter={[{
          xs: 16, sm: 16, md: 16, lg: 16
        }, {
          xs: 16, sm: 16, md: 27, lg: 27
        }]}
        className={classes.container}
      >
        <Col span={24}>
          <Title level={4} style={{ marginBottom: 0 }}>{t("dashboardPage.onboarding.title")}</Title>
        </Col>

        {OnboardingData.map((data) => (
          <Col span={24} md={8} key={data.title}>
            <Card size="small" style={{ height: "100%", border: "none" }} styles={{ body: { height: "100%", padding: 8 } }} >
              <Flex gap={10} vertical style={{ height: "100%" }}>
                <span className={classes.icon}>
                  {data.icon}
                </span>
                <Text className={classes.title}>{data.title}</Text>
                <Text className={classes.text}>{data.description}</Text>
                <Link to={data.path} style={{ marginTop: "auto" }}>
                  <Button type="primary" block>{data.button}</Button>
                </Link>
              </Flex>
            </Card>
          </Col>
        ))}
      </Row>
      <OnboardingModal isOpen={isModalOpen} handleToggle={toggleModal}/>
    </>
  );
};

export default Onboarding;
